var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKlarna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26651_38589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 0H0V12H55V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26651_38589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69513 0H6.98477C6.98477 2.16357 5.99319 4.19331 4.16426 5.39777L3.0625 6.24535L7.22716 11.7546H10.6647L6.85257 6.71376C8.72556 4.90706 9.69513 2.49814 9.69513 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82051 0H0V11.7546H2.82051V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9922 0H11.4141V11.7546H13.9922V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9537 3.34766C35.9621 3.34766 34.9926 3.59301 34.3756 4.41829V3.59301H31.9297V11.7566H34.3756V7.54097C34.3756 6.3365 35.235 5.73427 36.2266 5.73427C37.3283 5.73427 37.9453 6.3365 37.9453 7.54097V11.8681H40.3912V6.58186C40.5234 4.66364 39.0471 3.34766 36.9537 3.34766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9908 3.59301V4.08372C21.2416 3.59301 20.3822 3.34766 19.5228 3.34766C17.0769 3.34766 15.0938 5.26587 15.0938 7.67479C15.0938 10.0837 17.0549 12.0019 19.5228 12.0019C20.5144 12.0019 21.2416 11.7566 21.9687 11.2882V11.7789H24.4147V3.59301H21.9908ZM19.7652 9.81606C18.5312 9.81606 17.5617 8.85695 17.5617 7.78632C17.5617 6.71569 18.5533 5.75658 19.7652 5.75658C20.9992 5.75658 21.9687 6.71569 21.9687 7.78632C21.9908 8.85695 20.9992 9.81606 19.7652 9.81606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3594 4.66048V3.58984H25.7812V11.7534H28.3594V7.89468C28.3594 6.57869 29.8358 5.97646 30.8053 5.97646V3.58984C29.7256 3.58984 28.8662 4.05825 28.3594 4.66048Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2564 3.59301V4.08372C47.5072 3.59301 46.6478 3.34766 45.7884 3.34766C43.3425 3.34766 41.3594 5.26587 41.3594 7.67479C41.3594 10.0837 43.3205 12.0019 45.7884 12.0019C46.78 12.0019 47.5072 11.7566 48.2344 11.2882V11.7789H50.6803V3.59301H48.2564ZM46.0308 9.81606C44.7969 9.81606 43.8273 8.85695 43.8273 7.78632C43.8273 6.71569 44.8189 5.75658 46.0308 5.75658C47.2648 5.75658 48.2344 6.71569 48.2344 7.78632C48.2564 8.85695 47.2648 9.81606 46.0308 9.81606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4127 8.85547C52.5533 8.85547 51.8262 9.56922 51.8262 10.4168C51.8262 11.2644 52.5533 11.9781 53.4127 11.9781C54.2721 11.9781 54.9993 11.2644 54.9993 10.4168C54.9993 9.59153 54.2721 8.85547 53.4127 8.85547Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlarna);
export default __webpack_public_path__ + "static/media/klarna.0ee2611debf275c700b27ab226182ac4.svg";
export { ForwardRef as ReactComponent };